export const brandDummyData = {
  id: "dummy",
  brand_name_ch: "全部品牌",
  brand_name_en_full: "All",
};
